// extracted by mini-css-extract-plugin
module.exports = {"required":"InputYesNo_required_3sdJZ","error":"InputYesNo_error_xCmJZ","radioBox":"InputYesNo_radioBox_2jzeg","label":"InputYesNo_label_22CrK"};